import React from "react";
import PropTypes from "prop-types";

import dotIcon from "assets/img/dot.png";
import homeIcon from "assets/img/home_icon.png";
import industoryIcon from "assets/img/industory.png";

import "./BranchMarker.scss";

const ICON_BY_CLASSIFICATION = {
  1: industoryIcon,
  2: dotIcon,
  4: homeIcon
};

const BranchMarker = ({ branch, isHovered, alwaysShowPopup, onHoverChange }) => {
  const markerIcon = ICON_BY_CLASSIFICATION[branch.classification] || dotIcon;
  const popupVisible = alwaysShowPopup || isHovered;

  return (
    <div
      className="branch-marker-wrapper"
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
    >
      {popupVisible && (
        <div className="branch-popup">
          <div className="branch-popup__name">{branch.branch_nm}</div>
          {/* <div className="branch-popup__address">{branch.address}</div> */}
        </div>
      )}
      <div className="branch-pin">
        <img src={markerIcon} alt="" className="branch-pin__icon" />
      </div>
    </div>
  );
};

BranchMarker.defaultProps = {
  isHovered: false,
  alwaysShowPopup: false,
};

BranchMarker.propTypes = {
  branch: PropTypes.shape({
    id: PropTypes.number,
    branch_nm: PropTypes.string,
    address: PropTypes.string,
    classification: PropTypes.number,
  }),
  isHovered: PropTypes.bool,
  alwaysShowPopup: PropTypes.bool,
  onHoverChange: PropTypes.func,
};

export default BranchMarker;
